import loadable from '@loadable/component';

import './css/bootstrap-grid.min.css';

import Container from './container';
import landingPageMeta from './pages/landingPage/meta-data';
import discoverMeta from './pages/discover/meta-data';
import topicMeta from './pages/topic/meta-data';
import Spinner from './components/css_spinner/css_spinner';
import articlelMeta from './pages/articles/meta-data';
import journalMeta from './pages/journal/meta-data';
import itineraryMeta from './pages/itinerary/meta-data';
import loginMeta from './pages/login/meta-data';
import profileMeta from './pages/profile/meta-data';
import settingsMeta from './pages/settings/meta-data';
import invitationMeta from './pages/invitation/meta-data';
import poisMeta from './pages/pois/meta-data';
import aboutMeta from './pages/about/meta-data';
import hostelMeta from './pages/hostel/meta-data';
import notificationsMeta from './pages/notifications/meta-data';
import mytripsMeta from './pages/myTrips/meta-data';
import heatmapMeta from './pages/heatmap/meta-data';
import payMeta from './pages/pay/meta-data';
import checkPurchaseMeta from './pages/checkPurchase/meta-data';
import completePurchaseMeta from './pages/completePurchase/meta-data';
import collectionMeta from './pages/collections/meta-data';
import searchMeta from './pages/search/meta-data';
import experiencesMeta from './pages/experiences/meta-data';
import redirectOrderMeta from './pages/redirectOrder/meta-data';
import bookingMeta from './pages/booking/meta-data';
import myBookingsMeta from './pages/myBookings/meta-data';
import myCollectionsMeta from './pages/myCollections/meta-data';
import notFoundMeta from './pages/notFound/meta-data';
import myRewardsMeta from './pages/myRewards/meta-data';
import ssrMeta from './pages/ssr/meta-data';
import { MY_REFERRAL_PAGE } from './constants/routesPath';

const fallbackComponent = Spinner({ injectStyles: {} });

/** Reusable for SSR routes */
const ssrSpreading = {
  component: loadable(() => import('./pages/ssr/Ssr'), {
    fallback: fallbackComponent
  }),
  exact: true,
  loadData: ssrMeta
};

export default [
  {
    component: Container,
    routes: [
      /** @name City */
      {
        path: '/cities/:cityId',
        ...ssrSpreading
      },
      {
        path: '/cities/:cityId/:tabId',
        ...ssrSpreading
      },
      /** @name Discover */
      {
        path: '/',
        component: loadable(() => import('./pages/discover/Discover'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: discoverMeta
      },
      /** @name Site */
      {
        path: '/:site(jp|en|tw|cn|kr|hk)',
        component: loadable(() => import('./pages/discover/Discover'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: discoverMeta,
        metaClass: 'DiscoverMetaResponse'
      },
      /** @name Topics */
      {
        path: '/topics/:title',
        component: loadable(() => import('./pages/topic/Topic'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: topicMeta,
        metaClass: 'TopicMetaResponse'
      },
      /** @name Qrcode */
      {
        path: '/qrcode',
        component: loadable(() => import('./pages/landingPage/QRCode'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: landingPageMeta.qrcode
      },
      /** @name PrivacyPolicy */
      // Moved to `server/privacy.js` & `public/privacy/index.html`
      {
        path: '/privacy-policy',
        ...ssrSpreading
      },
      /** @name PrivacyPolicy */
      {
        path: '/yahoo-detail',
        component: loadable(() => import('./pages/landingPage/YahooDetail'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: landingPageMeta.privacyPolicy
      },
      /** @name Products */
      {
        path: '/:userid/products/:productid',
        ...ssrSpreading
      },
      /** @name Sim */
      {
        path: '/wifi-sim-card',
        ...ssrSpreading
      },
      /** @name CarRental */
      {
        path: '/car-rental',
        ...ssrSpreading
      },
      /** @name Pay */
      {
        path: '/:userid/products/:productid/pay',
        component: loadable(() => import('./pages/pay/Pay'), {
          fallback: fallbackComponent
        }),
        exact: true,
        isMember: true,
        loadData: payMeta
      },
      /** @name CheckPurchase */
      {
        path: '/checkout/:orderid',
        component: loadable(
          () => import('./pages/checkPurchase/CheckPurchase'),
          {
            fallback: fallbackComponent
          }
        ),
        exact: true,
        loadData: checkPurchaseMeta
      },
      /** @name CompletePurchase */
      {
        path: '/complete/:orderid',
        component: loadable(
          () => import('./pages/completePurchase/CompletePurchase'),
          {
            fallback: fallbackComponent
          }
        ),
        exact: true,
        loadData: completePurchaseMeta
      },
      /** @name Login */
      {
        path: '/login',
        component: loadable(() => import('./pages/login/LoginWebLayout'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: loginMeta
      },
      /** @name 3rd party Login callback path */
      {
        path: '/oauth/callback/:provider',
        component: loadable(() => import('./pages/login/LoginWebLayout'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: loginMeta
      },
      /** @name yahoologin */
      {
        path: '/yahoologin',
        component: loadable(() => import('./pages/login/YahooLogin'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: loginMeta
      },
      /** @name About */
      {
        path: '/about',
        component: loadable(() => import('./pages/about/About'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: aboutMeta
      },
      /** @name Hostel */
      {
        path: '/hostel',
        component: loadable(() => import('./pages/hostel/Hostel'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: hostelMeta
      },
      /** @name Invitation */
      {
        path: '/:userid/trips/:tripId/invitations/:invitationId',
        component: loadable(() => import('./pages/invitation/Invitation'), {
          fallback: fallbackComponent
        }),
        exact: true,
        isMember: true,
        loadData: invitationMeta
      },
      /** @name Collections folder */
      {
        path: '/:userid/collections/:folderid',
        component: loadable(() => import('./pages/collections/Collection'), {
          fallback: fallbackComponent
        }),
        exact: true,
        isMember: true,
        loadData: collectionMeta
      },
      /** @name Collections */
      {
        path: '/me/collections',
        component: loadable(
          () => import('./pages/myCollections/MyCollectionsWebLayout'),
          {
            fallback: fallbackComponent
          }
        ),
        exact: true,
        loadData: myCollectionsMeta
      },
      /** @name Articles */
      {
        path: '/:userid/articles/:articleid',
        component: loadable(() => import('./pages/articles/Article'), {
          fallback: fallbackComponent
        }),
        exact: true,
        isMember: true,
        loadData: articlelMeta
      },
      /** @name PoiDetails */
      {
        path: '/pois/:poiId',
        component: loadable(() => import('./pages/pois/Pois'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: poisMeta
      },
      /** @name Download */
      {
        path: '/download',
        component: loadable(() => import('./pages/landingPage/LandingPage'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: landingPageMeta.landingPage
      },
      /** @name Experience */
      {
        path: '/experiences',
        component: loadable(() => import('./pages/experiences/Experiences'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: experiencesMeta
      },
      /** @name Journals */
      {
        path: '/:userid/journals/:journalId',
        component: loadable(() => import('./pages/journal/Journal'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: journalMeta,
        isMember: true,
        metaClass: 'JournalMetaResponse'
      },
      /** @name Settings */
      {
        path: '/me/settings',
        component: loadable(() => import('./pages/settings/Settings'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: settingsMeta
      },
      /** @name Heatmap */
      {
        path: '/heatmap',
        component: loadable(() => import('./pages/heatmap/index'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: heatmapMeta
      },
      /** @name MyTrips */
      {
        path: '/me/trips',
        component: loadable(() => import('./pages/myTrips/MyTripsWebLayout'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: mytripsMeta
      },
      /** @name Search */
      {
        path: '/search',
        component: loadable(() => import('./pages/search/Search'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: searchMeta
      },
      /** @name Notifications */
      {
        path: '/me/notifications',
        component: loadable(
          () => import('./pages/notifications/Notifications'),
          {
            fallback: fallbackComponent
          }
        ),
        exact: true,
        loadData: notificationsMeta
      },
      /** @name Itinerary1 */
      {
        path: '/itinerary',
        component: loadable(() => import('./pages/itinerary/Itinerary'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: itineraryMeta,
        metaClass: 'TripMetaResponse'
      },
      /** @name Itinerary2 */
      {
        path: '/:userid/trips/:tripId',
        component: loadable(
          () => import('./pages/itinerary/ItineraryWebLayout'),
          {
            fallback: fallbackComponent
          }
        ),
        exact: true,
        loadData: itineraryMeta,
        isMember: true,
        metaClass: 'TripMetaResponse'
      },
      /** @name RedirectOrder */
      {
        path: '/me/orders',
        component: loadable(
          () => import('./pages/redirectOrder/RedirectOrder'),
          {
            fallback: fallbackComponent
          }
        ),
        exact: true,
        loadData: redirectOrderMeta
      },
      /** @name MyBookings */
      {
        path: '/me/bookings',
        component: loadable(() => import('./pages/myBookings/MyBookings'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: myBookingsMeta
      },
      /** @name BookingDetail */
      {
        path: '/me/bookings/:orderid',
        component: loadable(() => import('./pages/booking/Booking'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: bookingMeta
      },
      /** @name MyJournals */
      {
        path: '/me/journals',
        component: loadable(() => import('./pages/myJournals/MyJournals'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: journalMeta
      },
      /** @name EditJournal */
      {
        path: '/:userId/journals/:journalId/edit',
        component: loadable(() => import('./pages/myJournals/EditJournal'), {
          fallback: fallbackComponent
        }),
        exact: true,
        isMember: true,
        loadData: journalMeta
      },
      // /** @name Cars */
      // {
      //   path: '/cars',
      //   component: loadable(() => import('./pages/cars/Cars'), {
      //     fallback: fallbackComponent,
      //   }),
      //   exact: true,
      //   loadData: notFoundMeta,
      // },
      /** @name MyRewards */
      {
        path: '/me/rewards',
        component: loadable(() => import('./pages/myRewards/RedeemHistory'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: myRewardsMeta
      },
      /** @name RedeemHistory */
      {
        path: '/me/rewards/history',
        component: loadable(() => import('./pages/myRewards/RedeemHistory'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: myRewardsMeta
      },
      /** @name MyReferral */
      {
        path: MY_REFERRAL_PAGE,
        component: loadable(() => import('./pages/myReferral/MyReferral'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: notFoundMeta
      },
      /** @name Notfound */
      {
        path: '/notfound',
        component: loadable(() => import('./pages/notFound/NotFound'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: notFoundMeta
      },
      /** @name Profile */
      {
        path: '/:userid',
        component: loadable(() => import('./pages/profile/Profile'), {
          fallback: fallbackComponent
        }),
        exact: true,
        isMember: true,
        loadData: profileMeta,
        metaClass: 'ProfileMetaResponse'
      },
      {
        path: '/referrals/:code',
        component: loadable(() => import('./pages/login/LoginWebLayout'), {
          fallback: fallbackComponent
        }),
        exact: true,
        loadData: loginMeta
      }
    ]
  }
];
